import React, { type JSX } from 'react';

import { useAppDispatch } from '@fiji/common';
import { setWeekModeFilters } from '@fiji/common/src/features/schedule/schedulerSlice';
import { useGetFilterActionsQuery } from '@fiji/common/src/features/actions/actionsApi';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export const ActionFilterDropDown = React.memo((): JSX.Element => {
    const dispatch = useAppDispatch();
    const {
        data: allActions,
        isLoading,
        isFetching,
    }: any = useGetFilterActionsQuery(
        { body: {}, params: { all: true } },
        {
            refetchOnMountOrArgChange: true,
        }
    );
    return (
        <FormControl variant="filled" style={{ width: '18%' }}>
            <InputLabel id={'select-Assign-to-action'} required={false}>
                Action Type
            </InputLabel>
            <Select
                displayEmpty
                onChange={(e: any) => dispatch(setWeekModeFilters({ key: 'action', value: e.target.value }))}
                disabled={isLoading || isFetching}
            >
                {allActions?.data?.length &&
                    allActions?.data?.map((item: any) => (
                        <MenuItem key={item?.key} value={item?.key}>
                            {item?.displayName}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
});
